import { HttpStatusCode } from 'axios';

import { ErrorMessage } from '@/core/constants/ErrorMessage';
import MessageHelper from '@/core/helpers/MessageHelper';
import NumberHelper from '@/core/helpers/NumberHelper';
import StringHelper from '@/core/helpers/StringHelper';
import { Result } from '@/core/models/Result';

import EnvironmentVariableRepositoryInterface from '../interface-adapters/EnvironmentVariableRepositoryInterface';

export default class EnvironmentVariableRepository implements EnvironmentVariableRepositoryInterface {
    get(name: string): Result<string> {
        const result = new Result<string>();
        if (StringHelper.isHasValue(name) === false) {
            result.message = MessageHelper.format(ErrorMessage.NULL_OR_EMPTY_PARAMETER, 'page');
            result.responseCode = HttpStatusCode.BadRequest;
            return result;
        }

        result.data = import.meta.env[name];
        result.success = result.data !== null && result.data !== undefined;

        return result;
    }

    getAsInteger(name: string): Result<number> {
        let result = new Result<number>();

        const getDataResult = this.get(name);
        if (getDataResult.success === false) {
            result = result.copyExceptData(getDataResult);
            return result;
        }

        result.data = NumberHelper.parseInteger(getDataResult.data);
        result.success = result.data !== null;

        return result;
    }

    getAsBoolean(name: string): Result<boolean> {
        let result = new Result<boolean>();

        const getDataResult = this.get(name);
        if (getDataResult.success === false) {
            result = result.copyExceptData(getDataResult);
            return result;
        }

        result.data = getDataResult.data === '1' || getDataResult.data === 'true';
        result.success = result.data !== null;

        return result;
    }
}
